import initialState from "./initialState";
import {
    DISMISS_ERROR_ALERT,
    GET_POLL_ASSIGNMENT_DETAIL_FAIL,
    GET_POLL_ASSIGNMENT_DETAIL_SUCCESS, GET_POLL_ASSIGNMENT_TOKEN_FAIL, GET_POLL_ASSIGNMENT_TOKEN_SUCCESS,
    SUBMIT_POLL_RESPONSE_FAIL,
    SUBMIT_POLL_RESPONSE_SUCCESS,
    UPDATE_POLL_RESPONSE
} from "../../actions/pollPortal/pollPortalAction";
import {PortalUser} from "../../services/PortalUser";

export default function(state = initialState, action) {
    switch (action.type) {
        case DISMISS_ERROR_ALERT: {
            return {
                ...state,
                showErrorAlert: false,
            };
        }

        case GET_POLL_ASSIGNMENT_DETAIL_FAIL: {
            return {
                ...state,
                showErrorAlert: true
            };
        }

        case GET_POLL_ASSIGNMENT_DETAIL_SUCCESS: {
            return {
                ...state,
                pollAssignment: action.pollAssignment
            };
        }

        case GET_POLL_ASSIGNMENT_TOKEN_FAIL: {
            return {
                ...state,
                showErrorAlert: true
            };
        }

        case GET_POLL_ASSIGNMENT_TOKEN_SUCCESS: {
            PortalUser.setToken(action.token.accessToken, action.token.name);

            return {
                ...state,
                status: "PortalInfoReceived",
                redirectTo: "/pollPortal"
            };
        }

        case SUBMIT_POLL_RESPONSE_FAIL: {
            return {
                ...state,
                showErrorAlert: true,
                posting: false
            };
        }

        case SUBMIT_POLL_RESPONSE_SUCCESS: {
            return {
                ...state,
                pollResponseSuccessfullySaved: true,
                posting: false
            };
        }

        case UPDATE_POLL_RESPONSE: {
            return {
                ...state,
                selectedOptionId: action.optionId
            };
        }

        default:
            return state;
    }
}
